let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5oOX3")).then(() => parcelRequire('7SKBa'));